import { AlertTriangle, CloudOff, RefreshCw } from 'lucide-react';
import { useOfflineSync } from './useOfflineSync';

/**
 * Bandeau global affiché en haut de l'app si offline OU si pending sync > 0.
 * Brief §contraintes — "Indicateur visuel état connexion / sync".
 */
export const OfflineBanner = () => {
  const { online, counts, syncing, syncNow } = useOfflineSync();

  if (online && counts.total === 0) return null;

  const bg     = !online ? '#fef3c7' : counts.errors > 0 ? '#fee2e2' : '#dbeafe';
  const color  = !online ? '#92400e' : counts.errors > 0 ? '#dc2626' : '#1e40af';
  const border = !online ? '#fbbf24' : counts.errors > 0 ? '#fca5a5' : '#93c5fd';

  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 50,
      background: bg, color, borderBottom: `1px solid ${border}`,
      padding: '8px 16px', fontSize: 12, fontWeight: 600,
      display: 'flex', alignItems: 'center', gap: 12,
    }}>
      {!online ? (
        <>
          <CloudOff size={14} />
          📴 <strong>Hors ligne</strong> — vos saisies (voyages, bons carburant) sont sauvegardées localement et seront synchronisées au retour de connexion.
          {counts.total > 0 && (
            <span style={{ marginLeft: 'auto', padding: '2px 8px', background: 'rgba(0,0,0,.1)', borderRadius: 10 }}>
              {counts.total} en attente
            </span>
          )}
        </>
      ) : (
        <>
          <AlertTriangle size={14} />
          <span>{counts.total} saisie{counts.total > 1 ? 's' : ''} en attente de synchronisation</span>
          {counts.errors > 0 && (
            <span style={{ padding: '2px 8px', background: '#dc2626', color: 'white', borderRadius: 10, fontSize: 10 }}>
              {counts.errors} erreur{counts.errors > 1 ? 's' : ''}
            </span>
          )}
          <button
            type="button"
            onClick={() => void syncNow()}
            disabled={syncing}
            style={{
              marginLeft: 'auto', padding: '4px 12px', background: 'white', color,
              border: `1px solid ${border}`, borderRadius: 4, cursor: syncing ? 'wait' : 'pointer',
              fontSize: 11, fontWeight: 700, display: 'inline-flex', alignItems: 'center', gap: 6,
            }}
          >
            <RefreshCw size={12} className={syncing ? 'animate-spin' : ''} />
            {syncing ? 'Synchronisation…' : 'Synchroniser maintenant'}
          </button>
        </>
      )}
    </div>
  );
};
